<template>
    <v-container fluid grid-list-sm>
        <v-row>
            <v-col cols="12" sm="9">
                <h3 class="display-1 primary--text">Bookings</h3>
                <p v-if="!isWeekView">Courtesy Cars Manual: {{dayCcm}}</p>
                <p v-if="!isWeekView">Courtesy Cars Auto: {{dayCca}}</p>
            </v-col>
            <v-col cols="12" sm="3">
                <v-btn @click="launchModal" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn to="/booking/day" x-large class="float-right" color="secondary" fab icon><v-icon>mdi-printer</v-icon></v-btn>
                <v-checkbox color="primary" v-model="isWeekView" class="float-right" label="Week View" />
                <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="selectedDate" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="selectedDate" label="Selected Date" readonly v-on="on" />
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="selectedDate" no-title scrollable>
                        <v-spacer />
                        <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(selectedDate)">OK</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col v-if="isWeekView" cols="12" sm="12">
                <v-container fluid grid-list-sm>
                    <v-data-iterator :items="weekView" hide-default-footer :options="{itemsPerPage: 30}">
                        <template v-slot:default="props">
                            <v-row>
                                <v-col v-for="(item, index) in props.items" cols="12" sm="12" style="max-width: 350px" :key="index">
                                    <v-card width="350">
                                        <v-card-title>
                                            <v-row class="pl-1 pr-1">
                                                {{item.day | moment('dddd Do')}}
                                                <v-spacer />
                                                DT: {{item.dt}}
                                            </v-row>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row class="pl-1 pr-1 title">
                                                CCM: {{item.ccm}}
                                                CCA: {{item.cca}}
                                                TDO: {{item.tdo}}
                                                TPU: {{item.tpu}}
                                            </v-row>
                                            <v-row class="pl-1 pr-1 title red--text">
                                                <span v-if="item.events.length === 1">{{item.events[0].name}}</span>
                                                <template v-else>
                                                    <span v-for="(e, i) in item.events" :key="i">{{e.name}} | </span>
                                                </template>
                                            </v-row>
                                            <v-row>
                                                <v-data-iterator :options="{itemsPerPage: 30}" style="width: 100%" hide-default-footer no-data-text="No bookings for today" :items="item.bookings">
                                                    <template v-slot:item="propsInner">
                                                        <v-col class="mt-2" cols="12">
                                                            <booking-card :isWeekView="isWeekView" :item="propsInner.item" />
                                                        </v-col>
                                                    </template>
                                                </v-data-iterator>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-iterator>
                </v-container>
            </v-col>
            <v-col v-if="!isWeekView" cols="12" sm="12">
                <v-data-iterator :items="bookings" hide-default-footer :options="{itemsPerPage: 30}">
                    <template v-slot:default="props">
                        <v-row>
                            <v-col v-for="(item, index) in props.items" cols="12" sm="12" style="max-width: 350px" :key="index">
                                <booking-card-day :item="item" />
                            </v-col>
                        </v-row>
                    </template>
                </v-data-iterator>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {BookingsService} from "../../services/BookingsService";
    import BookingCard from "../cards/BookingCard";
    import BookingCardDay from "../cards/BookingCardDay";
    import {EventBus} from "../../EventBus";

    export default {
        name: "Bookings",
        components: {BookingCardDay, BookingCard},
        data() {
            return {
                today: this.$moment().format('dddd Do MMM YYYY'),
                selectedDate: new Date().toISOString().substr(0, 10),
                isWeekView: true,
                weekView: [],
                menu: false,
                dayCca: 0,
                dayCcm: 0
            }
        },
        async mounted() {
            this.updateBookings();
            EventBus.$on('refresh-bookings', () => {
                if (this.isWeekView) {
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(this.selectedDate).startOf('isoWeek').toDate(), isWeek: true})
                } else {
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(this.selectedDate).toDate(), isWeek: false})
                }
            });
        },
        methods: {
            launchModal() {
                this.$store.dispatch('bookings/setActiveBooking', {});
                this.$store.dispatch('bookings/setManageBookingDialog', true);
            },
            updateBookings() {
                if (this.isWeekView) {
                    this.weekView = [];
                    this.today = this.$moment().startOf('isoWeek').format('dddd Do MMM YYYY');
                    this.weekView = BookingsService.generateDays(this.$moment(this.selectedDate).startOf('isoWeek').toDate());
                    const tempEvents = BookingsService.etlEvents(this.events);
                    this.weekView = BookingsService.addEventsToArray(tempEvents, this.weekView);
                    this.weekView = BookingsService.addBookingsToArray(this.bookings, this.weekView);
                }
                if (!this.isWeekView) {
                    this.dayCcm = 0;
                    this.dayCca = 0;
                    if (this.bookings) {
                        this.bookings.forEach(b => {
                            if (b.isCCar && b.ccTypeManual) {
                                this.dayCcm = this.dayCcm +1;
                            }
                            if (b.isCCar && b.ccTypeAuto) {
                                this.dayCca = this.dayCca +1;
                            }
                        });
                    }

                }
            }
        },
        computed: {
            bookings: {
                get() {
                    return this.$store.state.bookings.bookings.bookings
                }
            },
            events: {
                get() {
                    return this.$store.state.bookings.bookings.events
                }
            }
        },
        watch: {
            selectedDate(newVal) {
                this.today = this.$moment(newVal).startOf('isoWeek').toDate();
                if (this.isWeekView) {
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(newVal).startOf('isoWeek').toDate(), isWeek: true})
                } else {
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(newVal).toDate(), isWeek: false})
                }
            },
            bookings: {
                handler() {
                    this.updateBookings();
                },
                deep: true,
                immediate: true
            },
            isWeekView(newVal) {
                if (!newVal) {
                    this.weekView = [];
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(this.selectedDate).toDate(), isWeek: false});
                    this.updateBookings();
                } else {
                    this.$store.dispatch('bookings/setBookings', {day: this.$moment(this.selectedDate).startOf('isoWeek').toDate(), isWeek: true})
                }
            }
        }
    }
</script>

<style scoped>

</style>
